import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

import { ref, getCurrentInstance, withDefaults, onMounted, watch } from 'vue';
import translate from '@/api/translate';

interface main {
	id?: string | number,
	size?: string,
	ValueKey?: string,
	LabelKey?: string,
	width?: string | number,
	disabled?: boolean,
	IsAuto?: boolean,
	WarehouseId?: string | number,
	AreaId?: string | number,
	RoadwayId?: string | number,
}
export default /*#__PURE__*/_defineComponent({
  __name: 'ShelvesSelect',
  props: {
    id: { default: "" },
    size: { default: "default" },
    ValueKey: { default: "value" },
    LabelKey: { default: "label" },
    width: { default: "100%" },
    disabled: { type: Boolean, default: false },
    IsAuto: { type: Boolean, default: false },
    WarehouseId: { default: "" },
    AreaId: { default: "" },
    RoadwayId: { default: "" }
  },
  emits: ["update:id", "change", "clear"],
  setup(__props: any, { emit: __emit }) {

;

const props = __props;

const { proxy } = getCurrentInstance() as any;
const emits = __emit;
const ShelvesId = ref<any>("");
const ShelvesList = ref<any>([]);
const loading = ref(false);
const placeholder = ref(translate.ShowText('请选择')); // 请选择...

watch(() => props.id, (n: any) => {
	ShelvesId.value = n;
});

onMounted(() => {
	ShelvesId.value = props.id;
	if (props.IsAuto) {
		if (proxy.$store.state.IsRefreshShelves) {
			GetData();
		} else {
			if (proxy.$store.state.ShelvesInfo) {
				if (proxy.$store.state.ShelvesInfo.wid == props.WarehouseId && proxy.$store.state.ShelvesInfo.aid == props.AreaId && proxy.$store.state.ShelvesInfo.rid == props.RoadwayId) {
					ShelvesList.value = proxy.$store.state.ShelvesInfo.list;
				} else {
					GetData();
				}
			} else {
				GetData();
			}
		}
	}
});

const ShelvesChange = (data: any) => {
	emits("update:id", data);
	emits("change", data);
};
const ShelvesClear = () => {
	emits("clear");
};
const SelectFocus = () => {
	if (proxy.$store.state.IsRefreshShelves) {
		GetData();
	} else {
		if (proxy.$store.state.ShelvesInfo) {
			if (proxy.$store.state.ShelvesInfo.wid == props.WarehouseId && proxy.$store.state.ShelvesInfo.aid == props.AreaId && proxy.$store.state.ShelvesInfo.rid == props.RoadwayId) {
				ShelvesList.value = proxy.$store.state.ShelvesInfo.list;
			} else {
				GetData();
			}
		} else {
			GetData();
		}
	}
};
const GetData = () => {
	loading.value = true;
	proxy.$api.tokenRequest({
		url: '/admin/warehouse/listByType',
		data: {
			type: 4,
			warehouse_id: props.WarehouseId,
			area_id: props.AreaId,
			road_id: props.RoadwayId,
			is_page: 0,
		},
		success: (res: any) => {
			loading.value = false;
			ShelvesList.value = res.data;
			proxy.$store.commit("GetAllList", {
				type: 11,
				wid: props.WarehouseId,
				aid: props.AreaId,
				rid: props.RoadwayId,
				list: res.data,
			});
		},
		fail: () => {
			loading.value = false;
		},
	});
};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, {
    "remote-show-suffix": "",
    filterable: "",
    clearable: "",
    style: _normalizeStyle({ 'width': `${_ctx.width}` }),
    disabled: _ctx.disabled,
    size: _ctx.size,
    modelValue: ShelvesId.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ShelvesId).value = $event)),
    loading: loading.value,
    onFocus: SelectFocus,
    placeholder: placeholder.value,
    onChange: ShelvesChange,
    onClear: ShelvesClear
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ShelvesList.value, (v) => {
        return (_openBlock(), _createBlock(_component_el_option, {
          key: v[_ctx.ValueKey],
          label: v[_ctx.LabelKey],
          value: v[_ctx.ValueKey]
        }, null, 8, ["label", "value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["style", "disabled", "size", "modelValue", "loading", "placeholder"]))
}
}

})